import registerRoutes from './routes';
import getAccountGroupsFactory from './services/list/getAccountGroups';
import addAccountGroupFactory from './services/add/addAccountGroup';

export default function (app) {
    app.factory('getAccountGroups', getAccountGroupsFactory);
    app.factory('addAccountGroup', addAccountGroupFactory);
    registerRoutes(app);
}



// WEBPACK FOOTER //
// ./Client/app/accountGroups/index.js